import { Box, Tooltip, Typography } from "@mui/material"
import { useUnitStyles } from "./unitStyles"

const safeParse = (value: any) => {
    try {
        return typeof value === "string" ? JSON.parse(value) : (value ?? {})
    } catch {
        return {}
    }
}

const BodyUnit = (props: any) => {
    const unit = safeParse(props.current)
    const styles = useUnitStyles()

    const st = unit?.storeStatus
    const hasSomething = !!unit?.zone || !!unit?.store || !!unit?.class

    const storeText = st?.text && st?.color
        ? `${unit?.store ?? "N/A"} - ${st.text}`
        : (unit?.store ?? "N/A")

    const zoneClassText = (unit?.zone || unit?.class)
        ? `${unit?.zone ?? "N/A"} - ${unit?.class ?? "N/A"}`
        : "N/A"

    return (
        <Box sx={styles.containerUnit}>
            {hasSomething ? (
                <>
                    <Tooltip title={storeText} placement="top" arrow>
                        <Typography
                            sx={[
                                styles.unitContent,
                                {
                                    whiteSpace: "normal",
                                    overflow: "visible",
                                    textOverflow: "unset",
                                    wordBreak: "break-word",
                                    overflowWrap: "anywhere",
                                },
                            ]}
                            className="w-full"
                        >
                            {unit?.store ?? "N/A"}

                            {!!st?.text && !!st?.color && (
                                <>
                                    {" - "}
                                    <Box
                                        component="span"
                                        sx={{
                                            color: st.color,
                                            fontSize: "inherit",
                                            fontWeight: "inherit",
                                            lineHeight: "inherit",
                                            display: "inline",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {st.text}
                                    </Box>
                                </>
                            )}
                        </Typography>
                    </Tooltip>

                    <Tooltip title={zoneClassText} placement="top" arrow>
                        <Typography sx={styles.unitContent} className="w-full custom-lines">
                            {zoneClassText}
                        </Typography>
                    </Tooltip>
                </>
            ) : (
                <Tooltip title="N/A" placement="top" arrow>
                    <Typography sx={styles.unitContent} className="w-full custom-lines">
                        N/A
                    </Typography>
                </Tooltip>
            )}
        </Box>
    )
}

export { BodyUnit }